import { render, staticRenderFns } from "./SideActions.vue?vue&type=template&id=2b0617df&scoped=true"
import script from "./SideActions.vue?vue&type=script&lang=ts"
export * from "./SideActions.vue?vue&type=script&lang=ts"
import style0 from "./SideActions.vue?vue&type=style&index=0&id=2b0617df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0617df",
  null
  
)

export default component.exports